export default __webpack_public_path__ + "static/media/phone-hand-background.f9316e55.svg";